import React from 'react';
import './Sem.css';
import semImage from '../assets/SEM.png';

const Sem = () => {
  return (
    <section className="sem-section">
      <div className="container sem-content">
        <div className="sem-text">
          <h5>SEM SERVICES</h5>
          <h2>Boost Visibility with Targeted SEM</h2>
          <p>
            Search Engine Marketing (SEM) is a powerful way to increase visibility and generate instant leads by displaying paid ads on search engines.
          </p>
          <ol>
            <li>Target the right customers at the right time with Google Ads.</li>
            <li>Drive measurable ROI using keyword-based campaigns.</li>
            <li>Track every click, conversion, and cost with analytics.</li>
          </ol>
          <button className="get-started-btn">Get Started</button>
        </div>
        <div className="sem-image-container">
          <img src={semImage} alt="SEM Services" />
        </div>
      </div>
    </section>
  );
};

export default Sem;
